import * as CreateAccountActionTypes from '../actionTypes/CreateAccountActionTypes';

export const createAccount = (accDetails) => ({
    type: CreateAccountActionTypes.CREATE_ACCOUNT,
    payload: accDetails,
});

export const createAccPageLoadedAction = (payload) => ({
    type: CreateAccountActionTypes.CREATE_ACCOUNT_PAGE_LOADED_SUCCESS,
    payload,
});

export const createAccCreationError = (details) => ({
    type: CreateAccountActionTypes.ACCOUNT_CREATION_ERROR,
    payload: details,
});

export const accountRegisteredAction = () => ({
    type: CreateAccountActionTypes.ACCOUNT_REGISTERED,
});

export const groupAPageLoadedAction = () => ({
    type: CreateAccountActionTypes.GROUPA_PAGE_LOADED_SUCCESS,
});

export const signoutPageLoadedAction = (payload) => ({
    type: CreateAccountActionTypes.SIGNOUT_PAGE_LOAD_ACTION,
    payload,
});
